<template>
  <fts-design-modal
    width="1280px"
    append-container-class="workflow-container"
    class="fts-workflow"
    ref="ftsDesignModal"
  >
    <!-- title -->
    <template #title>
      <fts-label-group
        :item="module"
        emoji
        :emoji-size="25"
        icon-class="design-modal-header-emoji"
        label-class="design-modal-header-name"
        class="design-modal-header-std__title"
        v-if="moduleId"
      />
      <div class="design-modal-header-title" v-else>Workflow</div>
    </template>
    <!-- description -->
    <template #description>
      <span class="design-modal-header-tag">Workflow</span>
      <span class="design-modal-header-description">
        diagram showing the flow of state to another state through activity
      </span>
    </template>
    <!-- body -->
    <template #body>
      <!-- diagram -->
      <div id="cy" class="workflow-diagram"></div>
    </template>
    <!-- footer -->
    <template #footerLeft>
      <fts-btn text @click="layout">Reset</fts-btn>
    </template>
    <template #footerRight>
      <fts-btn text @click="close">Cancel</fts-btn>

      <fts-btn outline color="primary" @click="done">
        <font-awesome-icon :icon="['fas', 'check']" /> Ok
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import cytoscape from "cytoscape";
import flowDiagram from "../library/flowDiagram";
import dagre from "cytoscape-dagre";
import edgeEditing from "../../external/cytoscape-edge-editing/index";
import cytoscapeContextMenus from "cytoscape-context-menus";

import jquery from "jquery";
import konva from "konva";

cytoscape.use(dagre);
cytoscape.use(cytoscapeContextMenus);

edgeEditing(cytoscape, jquery, konva);

import { store as canvasDesignStore } from "../store/canvasDesignStore";

import FTSDesignModal from "../design/FTSDesignModal";
import FTSLabelGroup from "../elements/FTSLabelGroup";
import FTSBtn from "./FTSBtn";

import "cytoscape-context-menus/cytoscape-context-menus.css";

export default {
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-label-group": FTSLabelGroup,
    "fts-btn": FTSBtn,
  },
  methods: {
    show() {
      this.$refs.ftsDesignModal.show();
      // set diagram
      this.$nextTick(() => {
        // every pseudo-state stays (no hideOrphans): a position is saved for each node, and one
        // that gains a flow later must still have one
        const elements = this.elements = flowDiagram.getElements(
          this.activities,
          this.states,
          this.flows,
          this.selection,
          this.diagram
        );

        const cy = this.cy = cytoscape({
          container: document.getElementById("cy"),
          wheelSensitivity: 0.1,
          layout: this.diagram != null ? { name: "preset" } : flowDiagram.getLayout(elements),
          style: flowDiagram.getStyle(),
          elements,
        });

        cy.edgeEditing({
          bendRemovalSensitivity: 16,
          enableMultipleAnchorRemovalOption: true,
          initAnchorsAutomatically: false,
          useTrailingDividersAfterContextMenuOptions: false,
          enableCreateAnchorOnDrag: true,
        });

        // bundled labels are placed by distance, which only exists once the layout has run
        cy.style().update();
      });
    },
    async done() {
      var nodes = this.cy.nodes();
      let diagramData = {
        nodes: [],
        edges: [],
      };
      nodes.forEach((node) => {
        diagramData.nodes.push({
          id: node.data().id,
          position: node.position(),
        });
      });

      var edges = this.cy.edges();
      edges.forEach((edge) => {
        diagramData.edges.push({
          id: edge.data().id,
          source: edge.data().source,
          target: edge.data().target,
          cyedgebendeditingDistances: edge.data().cyedgebendeditingDistances,
          cyedgebendeditingWeights: edge.data().cyedgebendeditingWeights,
        });
      });

      canvasDesignStore.dispatch("saveDiagram", diagramData);
      // the Studio saves the canvas on its own; a host that does not (the Builder) saves on this
      this.$emit("done", diagramData);
      this.close();
    },
    async layout() {
      canvasDesignStore.dispatch("saveDiagram", null);
      let layout = this.cy.layout(flowDiagram.getLayout(this.elements));
      layout.run();
      // bundled labels are placed by distance, which only exists once the layout has run
      this.cy.style().update();
    },
    close() {
      this.$refs.ftsDesignModal.close();
    },
  },
  computed: {
    moduleId() {
      return canvasDesignStore.state.vectorId;
    },
    module() {
      const module = canvasDesignStore.state.vector || {};
      return {
        id: module.id,
        name: module.name,
        emoji: module.emoji,
      }
    },
    states() {
      return canvasDesignStore.state.canvas.states;
    },
    flows() {
      return canvasDesignStore.state.canvas.flows;
    },
    activities() {
      return canvasDesignStore.state.canvas.activities;
    },
    selection() {
      return canvasDesignStore.state.selection;
    },
    diagram() {
      return canvasDesignStore.state.canvas.diagram;
    },
  },
};
</script>

<style lang="scss">
.fts-workflow {
  .workflow-container {
    height: 100%;
  }
  .workflow-diagram {
    width: 100%;
    height: 100%;
  }
}
</style>